
<div>
    <div class="dialog-header-container">
        <h2 mat-dialog-title class="mar-b-5 pd-t-5px">Modify Meeting </h2>
        <div>
            <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
    </div>
    <mat-divider class="mat-divider"></mat-divider>
    
    <form [formGroup]="reschedule">
        <div mat-dialog-content class="dialog-with-actions">
                <!-- <div mat-dialog-content >
                    <mat-form-field class="para-container input-field-formatting body-font-size">
                        <span>Meeting Title : {{meetingInfo.meetingData.meetingTitle}}</span>
                    </mat-form-field>
                </div> -->
                <div class="row m-0" style="padding: 10px 0px 10px 0px;">
                    <h3 class="body-font-size p-0"><span style="margin-right: 10px; font-weight: 500; font-style: italic;">Meeting Title :-</span>{{meetingInfo.meetingData.meetingTitle}}<Title></Title></h3>
                </div>
                <div class="row d-flex m-0">
                    <div class="col-md-6 ps-0">
                        <mat-form-field class="col-md-12 para-container input-field-formatting body-font-size">
                            <input  placeholder="Meeting Date" formControlName="meetingDateStr" class="due-Date editable-assignedTo body-font-size" #input type="text" [min]="currentDate" [matDatepicker]="picker" (focus)="picker.open()"  readonly matInput >
                            <!-- <input #input [formControl]="meetingDate" class="body-font-size" type="text"  [matDatepicker]="picker" (focus)="picker.open()"  readonly matInput placeholder="Meeting Date"> -->
                            <mat-datepicker (closed)="input.blur()" #picker class="body-font-size"></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 pe-0">
                        <mat-form-field class="col-md-12 para-container input-field-formatting body-font-size">
                            <input mask="Hh:m0" [dropSpecialCharacters]="false" formControlName="meetingStartTime" class="body-font-size" type="text"   matInput placeholder="Meeting Time"  name="name" autocomplete="off"  >
                        </mat-form-field>
                    </div>
                </div>
        </div>
        <div mat-dialog-actions class="d-flex justify-content-end p-0">
            <!-- <span><button class="button-container primary" type="button" mat-flat-button color="primary" (click)="rescheduleMeeting()">Save</button></span>&nbsp;&nbsp; -->
                <button class="button-container primary" type="button" mat-raised-button color="primary" (click)="rescheduleMeeting()">
                    SAVE
                </button>
                <button type="button" #editModalClose mat-raised-button color="primary" class="button-container primary" (click)="closeDialog()">
                    CANCEL
                </button>
        </div>
    </form>
</div>
